import Dashboard from '@/views/Dashboard/Dashboard.vue'
import Kalkulator from '@/views/Dashboard/Kalkulator.vue'
import Layout from '@/views/Dashboard/Layout.vue'
import Nasabah from '@/views/Dashboard/Nasabah.vue'
import NasabahAdd from '@/views/Dashboard/NasabahAdd.vue'
import NasabahDetail from '@/views/Dashboard/NasabahDetail.vue'
import NasabahEdit from '@/views/Dashboard/NasabahEdit.vue'
import Users from '@/views/Dashboard/Users.vue'
import UsersForm from '@/views/Dashboard/UsersForm.vue'
import Homepage from '@/views/Homepage.vue'
import Login from '@/views/Login.vue'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
      },
      {
        path: '/nasabah',
        name: 'nasabah',
        component: Nasabah,
      },
      {
        path: '/nasabah/add',
        name: 'nasabah_add',
        component: NasabahAdd,
      },
      {
        path: '/nasabah/edit',
        name: 'nasabah_edit',
        component: NasabahEdit,
      },
      {
        path: '/nasabah/detail',
        name: 'nasabah_detail',
        component: NasabahDetail,
      },


      // =============================
      // =============================
      // =============================

      
    ]
  },
  {
    path: '/testing_form',
    name: 'testing_form',
    component: Kalkulator
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return {top : 0}
  }
})

// 🔒 Route Guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token') // ganti sesuai cara simpan token

  if (to.meta.requiresAuth && !token) {
    // butuh login tapi tidak ada token
    next({ name: 'login' })
  } else if (to.name === 'login' && token) {
    // kalau sudah login & buka halaman login → lempar ke dashboard
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

export default router
